<template>
  <div class="d-flex flex-column align-center h-full py-10 overflow-x-auto">
    <v-card width="780" class="px-5" color="transparent" elevation="0">
      <p class="text-h4 font-weight-bold" :class="{ 'text-h5': $vuetify.breakpoint.mobile }">
        {{ $t("homeView.title") }}
      </p>
      <p class="text-h6 font-weight-regular mb-50" :class="{ 'text-body-1': $vuetify.breakpoint.mobile }">
        {{ $t("homeView.subtitle") }}
      </p>
      <div class="d-flex align-start mb-50">
        <v-hover v-model="hover" close-delay="200">
          <v-avatar @click="newImage" size="85" color="white" class="cursor-pointer">
            <v-overlay v-if="hover || $vuetify.breakpoint.mobile" :opacity="0.6" absolute>
              <v-icon size="28">$camera</v-icon>
            </v-overlay>
            <img :src="image" alt="" v-if="image" />
            <v-icon v-else size="55" color="primary">$user</v-icon>
          </v-avatar>
        </v-hover>
        <div class="ml-10">
          <p class="text-h6 font-weight-bold mb-1" :class="{ 'text-body-1': $vuetify.breakpoint.mobile }">
            {{ $t("homeView.image") }}
          </p>
          <p :class="{ 'text-body-2': $vuetify.breakpoint.mobile }">
            {{ $t("homeView.image2") }}
          </p>
          <p class="error--text mt-1" :class="{ 'text-body-2': $vuetify.breakpoint.mobile }">
            {{ $t("homeView.image3") }}
          </p>
        </div>
      </div>
      <v-form ref="form" v-model="valid" lazy-validation>
        <div class="mt-2">
          <p class="font-weight-bold text-body-1">{{ $t("homeView.name") }}</p>
          <v-text-field solo class="font-weight-bold" hide-details="auto" flat :rules="[rules.required]"
            v-model="forms.nome">
            <template v-slot:message="{ message }">
              {{ $t(message) }}
            </template>
          </v-text-field>
          <p class="font-weight-bold text-body-1 mt-6">
            {{ $t("homeView.email") }}
          </p>
          <v-text-field solo class="font-weight-bold" disabled hide-details="auto"
            :rules="[rules.required, rules.email]" flat v-model="forms.email">
            <template v-slot:message="{ message }">
              {{ $t(message) }}
            </template>
          </v-text-field>
          <p class="font-weight-bold text-body-1 mt-6">
            {{ $t("homeView.language") }}
          </p>
          <v-select solo class="font-weight-bold" hide-details="auto" flat :value="$i18next.language" @input="
            (lg) => {
              lang = lg;
              forms.idioma = lg;
            }
          " :items="[
            { text: 'Português', value: 'br' },
            { text: 'Inglês', value: 'en' },
          ]" append-icon="$arrow-down"></v-select>
          <p class="font-weight-bold text-body-1 mt-6">
            {{ $t("homeView.theme") }}
          </p>
          <v-select solo class="font-weight-bold" hide-details="auto" flat v-model="forms.tema" :items="[
            { text: 'Escuro', value: 'dark' },
            { text: 'Claro', value: 'light' },
          ]" append-icon="$arrow-down"></v-select>
          <div class="d-flex align-center justify-space-between mt-7">
            <div class="relative" style="width: 52px; height: 52px" v-if="status === 'LOADING-PASSWORD'">
              <v-progress-circular value="100" class="absolute" color="black" size="30"></v-progress-circular>
              <v-progress-circular indeterminate class="absolute" color="primary" size="30"></v-progress-circular>
            </div>
            <p v-else class="font-weight-bold text-body-1 primary--text cursor-pointer"
              :class="{ 'text-body-2': $vuetify.breakpoint.mobile }" @click="recoveryPass">
              {{ $t("homeView.changePassword") }}
            </p>
            <v-btn v-ripple="false" color="success" :loading="status === 'LOADING'"
              :height="$vuetify.breakpoint.mobile ? 36 : 54" :width="$vuetify.breakpoint.mobile ? 144 : 180"
              :class="{ 'text-body-2': $vuetify.breakpoint.mobile }" class="font-weight-bold text-body-1"
              @click="saveEdit">{{ $t("homeView.save") }}</v-btn>
          </div>
        </div>
      </v-form>
      <v-card class="pa-6 mb-50 mt-6 rounded-base">
        <p class="font-weight-bold text-h6 mb-14">{{ $t("homeView.apps") }}</p>
        <div class="d-flex align-center justify-space-between">
          <a :href="redirects.planeja" class="d-flex align-center disabled" style="color: inherit">
            <img :src="require(`@/assets/planeja${isDark ? '' : '-dark'}.svg`)" width="32" class="mr-5" />
            <p class="font-weight-bold text-h6">
              Planeja<span class="font-weight-regular">Conta</span>
            </p>
          </a>
          <!-- <v-btn
            color="bg"
            style="border: 1px solid"
            :style="{
              borderColor: $vuetify.theme.themes.dark.error + '!important',
            }"
            v-ripple="false"
            :height="$vuetify.breakpoint.mobile ? 36 : 54"
            :width="$vuetify.breakpoint.mobile ? 144 : 180"
            class="text-body-1 error--text"
            :class="{ 'text-body-2': $vuetify.breakpoint.mobile }"
            >{{ $t("homeView.desative") }}</v-btn
          > -->
        </div>
        <div class="d-flex align-center justify-space-between mt-3">
          <a :href="redirects.nitrogen" class="d-flex align-center disabled" style="color: inherit">
            <img :src="require(`@/assets/nitrogen${isDark ? '' : '-dark'}.svg`)" width="32" class="mr-5" />
            <p class="font-weight-bold text-h6">
              Nitrogen
            </p>
          </a>
          <!-- <v-btn
            color="bg"
            style="border: 1px solid"
            :style="{
              borderColor: $vuetify.theme.themes.dark.error + '!important',
            }"
            v-ripple="false"
            :height="$vuetify.breakpoint.mobile ? 36 : 54"
            :width="$vuetify.breakpoint.mobile ? 144 : 180"
            class="text-body-1 error--text"
            :class="{ 'text-body-2': $vuetify.breakpoint.mobile }"
            >{{ $t("homeView.desative") }}</v-btn
          > -->
        </div>
        <!-- <div class="d-flex align-center justify-space-between mt-8">
          <div class="d-flex align-center">
            <img src="@/assets/board.svg" width="32" class="mr-5" />
            <p
              class="font-weight-bold text-h6"
              v-if="!$vuetify.breakpoint.mobile"
            >
              b²oard
            </p>
          </div>
          <v-btn
            color="bg"
            style="border: 1px solid"
            :style="{
              borderColor: $vuetify.theme.themes.dark.success + '!important',
            }"
            v-ripple="false"
            :height="$vuetify.breakpoint.mobile ? 36 : 54"
            :width="$vuetify.breakpoint.mobile ? 144 : 180"
            class="text-body-1 success--text"
            :class="{ 'text-body-2': $vuetify.breakpoint.mobile }"
            >{{ $t("homeView.active") }}</v-btn
          >
        </div> -->
      </v-card>
      <!-- <v-card
        class="d-flex align-center justify-space-between pa-12 mt-50 mb-10 rounded-base"
        :class="{ 'flex-column': $vuetify.breakpoint.mobile }"
        elevation="0"
        style="border: 1px solid"
        :style="{
          borderColor: $vuetify.theme.themes.dark.warning + '!important',
        }"
      >
        <p :class="{ 'mb-6': $vuetify.breakpoint.mobile }">
          {{ $t("homeView.textdelete") }} <br />
          {{ $t("homeView.textdelete2") }}
        </p>

        <v-btn
          color="bg"
          style="border: 1px solid"
          :style="{
            borderColor: $vuetify.theme.themes.dark.warning + '!important',
          }"
          v-ripple="false"
          :height="$vuetify.breakpoint.mobile ? 36 : 54"
          :width="$vuetify.breakpoint.mobile ? 144 : 180"
          :class="{ 'text-body-2': $vuetify.breakpoint.mobile }"
          class="text-body-1 warning--text"
          >{{ $t("homeView.delete") }}</v-btn
        >
      </v-card> -->
      <div class="d-flex justify-center mt-10">
        <p class="font-weight-bold text-h6 error--text cursor-pointer" @click="logout">
          {{ $t("homeView.signout") }}
        </p>
      </div>
    </v-card>
    <!-- <img :src="image" v-if="image" /> -->
    <modal-edit-image v-model="modal" :image="imageSave" />
  </div>
</template>

<script>
import ModalEditImage from "@/components/ModalEditImage.vue";
import { useAuthStore } from "@/stores/auth";
import { useThemeStore } from "@/stores/theme";
import { mapState, mapWritableState, mapActions } from "pinia";
import { rules } from "@/mixins/rules";
import { redirects } from "@/plugins/constrains";
export default {
  components: { ModalEditImage },

  data: () => ({
    redirects,
    rules,
    hover: false,
    imageSave: "",
    valid: true,
    mode: "DAY",
    modal: false,
    input: null,
    data: "2023-01-05",
    forms: {
      nome: "",
      email: "",
      idioma: "",
      tema: "",
    },
  }),
  watch: {
    "forms.tema"(value) {
      this.isDark = value === "dark";
    },
  },
  async created() {
    if (this.$route?.query?.url_back) {
      this.url_back = this.$route?.query?.url_back;
      this.$router.replace({ name: this.$route.name, query: {} });
    } else {
      this.url_back = "";
    }

    this.$nextTick(() => (this.status = ""));
    await this.getUser();
    this.forms.nome = this.name;
    this.forms.email = this.email;
    this.forms.idioma = this.idioma || "br";
    this.lang = this.forms.idioma;
    this.forms.tema = this.tema || "dark";
  },
  computed: {
    ...mapState(useAuthStore, ["image"]),
    ...mapWritableState(useThemeStore, ["isDark", "lang"]),
    ...mapWritableState(useAuthStore, [
      "userId",
      "name",
      "email",
      "idioma",
      "tema",
      "url_back",
      "status",
    ]),
  },
  methods: {
    ...mapActions(useAuthStore, [
      "logout",
      "editAccount",
      "recoveryPassword",
      "getUser",
    ]),
    async saveEdit() {
      await this.$refs.form.validate();
      if (this.valid) this.editAccount({ ...this.forms, userId: this.userId });
    },
    async recoveryPass() {
      await this.recoveryPassword();
    },
    newImage() {
      this.input = document.createElement("input");
      this.input.type = "file";
      this.input.accept = "image/*";

      this.input.onchange = () => {
        const file = this.input.files[0];
        // if (file.size >= 5000000) {
        //   this.$toast.error("Utilize uma imagem de no máximo 5Mb");
        //   return;
        // }
        this.file = file;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.imageSave = reader.result;
          this.modal = true;
        };
      };
      this.input.click();
    },
  },
};
</script>